import { render, staticRenderFns } from "./MarketingVouchers.vue?vue&type=template&id=bbc8b070&scoped=true"
import script from "./MarketingVouchers.vue?vue&type=script&lang=js"
export * from "./MarketingVouchers.vue?vue&type=script&lang=js"
import style0 from "./MarketingVouchers.vue?vue&type=style&index=0&id=bbc8b070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc8b070",
  null
  
)

export default component.exports